var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",class:[_vm.eventsData.isLoading ? 'loading' : 'not-loading']},[_c('div',{staticClass:"page-builder-container"},[_c('page-builder',{attrs:{"contentName":"home"}})],1),_vm._v(" "),_c('div',{staticClass:"spacer"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-928770a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/apps/booking/components/home/Home.html
// module id = null
// module chunks = 